import React from 'react';
import { FiHome, FiHeart, FiZap, FiTrendingUp } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const WhyChooseUs = () => {
  const benefits = [
    {
      icon: FiHome,
      title: 'No Hospitalization',
      description: 'All treatments are outpatient procedures. Return to your daily activities immediately after treatment.',
      gradient: 'from-blue-100 to-blue-50',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600'
    },
    {
      icon: FiHeart,
      title: 'No Medicine',
      description: 'Drug-free healing approach that works with your body\'s natural recovery mechanisms.',
      gradient: 'from-red-100 to-red-50',
      iconBg: 'bg-red-100',
      iconColor: 'text-red-600'
    },
    {
      icon: FiZap,
      title: 'No Surgery',
      description: 'Non-invasive treatments that eliminate surgical risks and lengthy recovery periods.',
      gradient: 'from-emerald-100 to-emerald-50',
      iconBg: 'bg-emerald-100',
      iconColor: 'text-emerald-600'
    },
    {
      icon: FiTrendingUp,
      title: 'Fast Recovery',
      description: 'Experience significant improvement within the first few sessions with lasting results.',
      gradient: 'from-purple-100 to-purple-50',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-gray-50 to-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Why Choose JIVA NADI?
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Experience the difference of truly holistic healthcare that prioritizes your well-being 
            and delivers results without compromising your body's natural processes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="group">
              <div className={`bg-gradient-to-br ${benefit.gradient} rounded-2xl p-8 h-full shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-white`}>
                <div className="text-center space-y-6">
                  <div className={`inline-flex items-center justify-center w-20 h-20 ${benefit.iconBg} rounded-2xl group-hover:scale-110 transition-transform duration-300`}>
                    <SafeIcon icon={benefit.icon} className={`w-10 h-10 ${benefit.iconColor}`} />
                  </div>
                  
                  <div className="space-y-3">
                    <h3 className="text-2xl font-bold text-gray-900">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-white rounded-2xl p-8 shadow-xl max-w-4xl mx-auto border border-emerald-100">
            <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
              Ready to Experience Natural Healing?
            </h3>
            <p className="text-lg text-gray-700 mb-6">
              Join thousands of patients who have chosen the safe, effective, and natural path to pain relief.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 shadow-lg hover:shadow-xl">
                Book Your Consultation
              </button>
              <button className="bg-white hover:bg-gray-50 text-emerald-600 px-8 py-3 rounded-full font-semibold border-2 border-emerald-200 hover:border-emerald-300 transition-all duration-300">
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;